<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>
                Der Entwurf beruht auf der Idee eines beliebig erweiterbaren und modularisierten Wohnmöbelsystems, welches sich auf zwei Grundmodule reduzieren lässt. Der quadratische Kubus lässt sich durch den Verbindungskeil flexibel in alle Richtungen anordnen und erweitern. Die Module sind stapelbar und mehrgeschossig zu kombinieren.
            </p>
            <p>
                Die ungewöhnlich starke Massivholzwand ist gestalterisches Merkmal des Entwurfs. Darüber hinaus ist sie als homogenes Bauelement besonders benutzerfreundlich und experimentell in der Konstruktion. Ein gutes Raumklima ist durch das naturbelassene und nachwachsende Material Holz gegeben.
            </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach mit Spacekitchen</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/sozialschnellgut_1_a.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_2_a.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_3_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_4_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_5_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_6_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_7_a.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_7_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_8_a.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_8_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_9_b.jpg' ),
                require( '@/assets/img/pc/sozialschnellgut_10_a.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>